import { useDispatch } from "react-redux";

import { changeCurrentPopup } from "./../store/ui/actionCreators";
import { ICurrentPopupData } from "./../store/ui/types";
import EMITTER, { Events } from "./../emitter";
import { withoutBlurItems } from "./../helpers/common";
import useShallowSelector from "./useShalowSelector";
import { selectUIAuthPopUpRender } from "../store/ui/selectors";
import { IEmailEditorData } from "../store/settings/types";

export interface handleOpen {
    (popupType: ICurrentPopupData, callback?: Function, initialText?: string | IEmailEditorData): void;
}

export interface handleClose {
    (popupType?: ICurrentPopupData): void;
}

type UsePopup = () => {
    onOpen: handleOpen;
    onClose: handleClose;
};

const usePopup: UsePopup = () => {
    const dispatch = useDispatch();
    const authProps = useShallowSelector(selectUIAuthPopUpRender);

    const handleOpen: handleOpen = (popupType, callback, initialText) => {
        EMITTER.emit(Events.POPUP_OPEN, popupType, callback, initialText);

        if (popupType && !authProps && !withoutBlurItems.includes(popupType))
            document.getElementById("blurable")!.style.filter = "blur(10px)";
    };

    const handleClose: handleClose = popupType => {
        dispatch(changeCurrentPopup(null));
        if ((popupType && !withoutBlurItems.includes(popupType)) || !popupType)
            document.getElementById("blurable")!.style.filter = "blur(0px)";
    };

    return { onOpen: handleOpen, onClose: handleClose };
};

export default usePopup;
